export const LanguageResourcesDictionary: Record<string, string> = {
    English: "Resources",
    German: "Quellen",
    Spanish: "Recursos",
    French: "Ressources",
    Italian: "Risorse",
    Portuguese: "Recursos",
    Dutch: "Middelen",
    Russian: "Ресурсы",
    Chinese: "资源",
    Japanese: "リソース",
    Korean: "자원",
    Arabic: "الموارد",
    Hindi: "संसाधन",
    Bengali: "সম্পদ",
    Turkish: "Kaynaklar",
    Vietnamese: "Tài nguyên",
    Polish: "Zasoby",
    Ukrainian: "Ресурси",
    Persian: "منابع",
    Kurdish: "سەرچاوەکان",
    Tigrinya: "መሰረታት",
    Somali: "Khayraadka",
    Dari: "منابع",
    Pashto: "سرچینې",
};

// Helper function to get the translation based on the language
export const getResourceTranslation = (language: string): string => {
    return LanguageResourcesDictionary[language] || LanguageResourcesDictionary.German;
};